import { FC } from 'react';
import { withStyles } from 'vopay';
import styles from './DomainSetupPage.module.scss';
import Home from './Home';
import ViewDomain from './ViewDomain';
import { useToast } from '@/providers/Toast.provider';
import useDomainSetup from './useDomainSetup';
import { useConfirmDialog } from '@/providers/ConfirmDialog.provider';
import { useHistory } from 'react-router-dom';
import { UtilButton } from 'UI';
import { useTranslation } from 'react-i18next';

const classes = withStyles(styles);

const DomainSetup: FC = () => {
  const toast = useToast();
  const { fetching, domain, addDomain, verifyDomain, deleteDomain } = useDomainSetup();
  const confirmDialog = useConfirmDialog();

  const { t } = useTranslation('translations', { keyPrefix: 'Settings' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const history = useHistory();

  const handleAddDomain = async (url: string) => {
    const res = await addDomain(url);

    if (!res.Success) {
      console.error(res.ErrorMessage);

      await confirmDialog.error('Something went wrong', {
        subTitle: `Could not add ${url}`,
        cancelLabel: 'Close',
      });

      return;
    }

    toast.success('Domain Added');
  };

  const handleVerifyDomain = async () => {
    if (!domain) return;

    const res = await verifyDomain(domain.Domain);

    if (!res.Success) {
      console.error(res.ErrorMessage);

      await confirmDialog.error('Something went wrong', {
        subTitle: `Could not verify ${domain.Domain}`,
        cancelLabel: 'Close',
      });

      return;
    }

    if (res.Domain.Status === 'verified') {
      toast.success('Domain Verified');
    } else {
      toast.neutral(`Domain couldn't be verified`);
    }
  };

  const handleDeleteDomain = async () => {
    if (!domain) return;

    const res = await deleteDomain(domain.Domain);

    if (!res.Success) {
      await confirmDialog.error('Something went wrong', {
        subTitle: `Could not delete ${domain.Domain}`,
        cancelLabel: 'Close',
      });

      return;
    }

    toast.success('Domain Deleted');
  };

  return (
    <div className={classes('domainSetupPageContainer')}>
      <h1 className={classes('header')}>
        <UtilButton
          iconLeft="chevron_left"
          size="large"
          onClick={() => {
            if (history.length > 1) {
              history.goBack();
            } else {
              history.replace('/settings');
            }
          }}
        >
          {history.length > 1 ? tGlobal('Buttons.back') : t('pageTitle')}
        </UtilButton>
        Verified Senders
      </h1>

      {fetching ? null : domain ? (
        <ViewDomain domain={domain} onDelete={handleDeleteDomain} onVerify={handleVerifyDomain} />
      ) : (
        <Home domain={domain} onAddDomain={handleAddDomain} />
      )}
    </div>
  );
};

export default DomainSetup;
